import type { UserConsentId } from '@paid-ui/enums/consent';

import { Suspense } from 'react';
import { useRouter } from 'next/router';

import { consentIdTitleMap, consentIdTypeMap } from '@paid-ui/constants';
import { SVGIcon } from '@paid-ui/icons';
import { closeConsentDialog } from '@paid-ui/models/dialog';
import { useGetConsent } from '@paid-ui/queries/consent';
import { Dialog, LoadingIndicator, Spinner } from '@paid-ui/ui';

import { DialogCloseButton, DialogHeader } from './_Base';

const Consent = () => {
  const router = useRouter();
  const consentId = router.query.consentId as UserConsentId;
  const open = Boolean(consentIdTypeMap[consentId]);

  const title = consentIdTitleMap[consentId];
  const { data: source, isLoading } = useGetConsent(consentId);

  return (
    <Dialog open={open} onOpenChange={closeConsentDialog}>
      <Suspense fallback={<LoadingIndicator />}>
        <div className="flex h-full w-full flex-col">
          <DialogHeader>
            <h2 className="truncate">{title}</h2>
            <DialogCloseButton type="button" onClick={closeConsentDialog}>
              <SVGIcon name="close" />
            </DialogCloseButton>
          </DialogHeader>
          {isLoading || !source ? (
            <div className="color-blue flex h-full w-full flex-col items-center justify-center">
              <Spinner size="lg" color="$blue" emptyColor="$fgFaint" />
            </div>
          ) : (
            <iframe
              className="flex-1 bg-white"
              loading="lazy"
              src={`${source.link}#toolbar=0`}
              title={title}
              width="100%"
            />
          )}
        </div>
      </Suspense>
    </Dialog>
  );
};

export default Consent;
Consent.displayName = 'Consent';
